import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { ModalProps } from '../../../../services/modals.service';
import { useModalClose } from '../../../../utils/useModalClose';
import CalculatorCustomsDeliveryBlock, {
  CalculateCustomsDeliveryFormType,
  CalculatedTksData,
} from './calculator-customs-delivery-block';
import CalculationResultCustomsDeliveryBlock from './calculation-result-customs-delivery-block';
import {
  CleanCustomsDeliveryOrderGood,
  CustomsDeliveryCurrency,
  CustomsDeliveryVat,
} from '../../../../export-types/cleaned-types';

type Props = ModalProps & {
  defaultValues: CleanCustomsDeliveryOrderGood;
  onSubmit: (data: TksGood) => Promise<void>;
};
type TksGood = {
  name: string;
  code: string;
  price: number;
  currency: CustomsDeliveryCurrency;
  amount?: number;
  costs: {
    fee: { price: number; sum: number; info: string };
    tolls: { price: number; sum: number; info: string }[];
    vat: { price: number; sum: number; info: string };
  };
  sumCost: number;
  vat?: CustomsDeliveryVat;
};

export const CustomsDeliveryOrderGoodEditModal: React.FC<Props> = (props) => {
  const [selectedData, setSelectedData] =
    useState<CalculateCustomsDeliveryFormType>();
  const [calculatedData, setCalculatedData] = useState<CalculatedTksData>();
  const modalRef = useModalClose(props.reject);

  return (
    <div className="modal-dialog" ref={modalRef}>
      <div className={'modal-content'}>
        <div className="modal-header border-bottom-0 p-4">
          <h3>
            <FormattedMessage
              defaultMessage="Изменение кода ТН ВЭД"
              id="customsDeliveryOrderGoodEditModal.title.changeOfTNVEDCode"
              description="Заголовок модального окна"
            />
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => props.reject()}
          />
        </div>

        <div className="modal-body pt-2 p-4">
          <CalculatorCustomsDeliveryBlock
            defaultValues={{
              ...props.defaultValues,
              vat: props.defaultValues.vat
                ? {
                    value: props.defaultValues.vat,
                    label: props.defaultValues.vat,
                  }
                : undefined,
              amount: props.defaultValues.amount || null,
              price: props.defaultValues.price || 0,
              selectedCode: {
                name: props.defaultValues.name,
                code: props.defaultValues.codeTariff || '',
                unit: null,
              },
              currency:
                CustomsDeliveryCurrency[props.defaultValues.currency || 'cny'],
              code: props.defaultValues.codeTariff || '',
            }}
            setCalculatedData={setCalculatedData}
            setSelectedData={setSelectedData}
          />
          {calculatedData && selectedData && (
            <div className={'mt-2'}>
              <CalculationResultCustomsDeliveryBlock
                calculationData={calculatedData}
                submitButtonTitle={'Добавить в заказ'}
                onSubmit={async () => {
                  await props.onSubmit({
                    amount: selectedData.amount || undefined,
                    price: selectedData.price,
                    name: selectedData.selectedCode?.name || '',
                    code: selectedData.code,
                    currency: selectedData.currency,
                    costs: {
                      fee: calculatedData.fee,
                      tolls: calculatedData.tolls,
                      vat: calculatedData.nds,
                    },
                    vat: selectedData.vat.value,
                    sumCost: calculatedData.total,
                  });
                  props.close();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
